import { type IFlatNavigationItem } from '@workinance/shared/ui/AppShellLayoutComponent';
import {
	BillingIcon,
	BusinessIcon,
	DashboardIcon,
} from '@workinance/shared/ui/icons';

export const navigation: IFlatNavigationItem[] = [
	{ label: 'Overview', to: '/dashboard', icon: DashboardIcon },
	{ label: 'Businesses', to: '/businesses', icon: BusinessIcon },
	{ label: 'Billing', to: '/billing', icon: BillingIcon },
];
